/**
 * Utilitário centralizado para gerenciamento e limpeza do rascunho de agendamento no localStorage
 */

export const SCHEDULING_STORAGE_KEYS = [
  'pedidoId',
  'customer_stepData',
  'stepData',
  'customer_employeesData',
  'customer_employeesData_empresa_id',
  'employeesData',
  'customer_examsData',
  'examsData',
  'customer_schedulingData',
  'schedulingData',
  'customer_finalizationData',
  'finalizationData',
  'employeeFormData',
  'pixData',
] as const;

/**
 * Remove todos os dados temporários de rascunho, passos e colaboradores do agendamento
 */
export function limparRascunhoAgendamento(): void {
  try {
    // 1. Remove explicit keys
    SCHEDULING_STORAGE_KEYS.forEach((key) => {
      localStorage.removeItem(key);
    });

    // 2. Scan dynamically to catch any residual or prefixed draft keys
    const preservedAuthKeys = new Set([
      'customer_token',
      'customer_user',
      'customer_empresa_id',
      'token',
      'user',
      'empresa_id',
      'timezone',
      'customer_timezone',
      'theme',
    ]);

    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && !preservedAuthKeys.has(key)) {
        const lower = key.toLowerCase();
        if (
          lower.includes('employee') ||
          lower.includes('colaborador') ||
          lower.includes('stepdata') ||
          lower.includes('examsdata') ||
          lower.includes('scheduling') ||
          lower.includes('finalization') ||
          lower.includes('pixdata') ||
          lower.includes('pedidoid') ||
          lower.includes('rascunho')
        ) {
          keysToRemove.push(key);
        }
      }
    }

    keysToRemove.forEach((k) => localStorage.removeItem(k));
    console.log('🧹 [AgendamentoStorage] Todos os dados de rascunho de agendamento foram limpos com sucesso.');
  } catch (error) {
    console.warn('⚠️ [AgendamentoStorage] Erro ao limpar localStorage do agendamento:', error);
  }
}
